import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { setSnackbarMessage } from '../../actions/snackbar'
import { RaisedButton } from 'material-ui'
import debounce from 'lodash/debounce'
import api from '../../api'
import FieldList from '../fieldList'

class CreateAssociation extends Component<any, any> {
  static initialState = {
    resource: {},
    errors: {},
    autocompleteResults: {},
    autocompleteText: {}
  }

  constructor (props) {
    super(props)
    this.state = CreateAssociation.initialState
// @ts-ignore
    this.debouncedAutocompleteUpdate = debounce(this.performAutocompleteUpdate.bind(this), 500)
  }

  handleAutocompleteFocus (field) {
    if (this.state.autocompleteText[field.references] === undefined) {
      this.handleAutocompleteUpdateInput(field, '')
    }
  }

  handleAutocompleteUpdateInput (field, searchText) {
    this.setState({
      autocompleteText: Object.assign({}, this.state.autocompleteText, {
        [field.references]: Object.assign({}, this.state.autocompleteText[field.references], {
          [field.prop]: searchText
        })
      })
    })

    // Debounce the API call
// @ts-ignore
    this.debouncedAutocompleteUpdate(field, searchText)
  }

  performAutocompleteUpdate (field, searchText) {
    const excludeIds = this.props.excludeAutocompleteIds[field.prop]

    const apiQuery = {
      filters: {
        [`${field.referenceProp}_ilike`]: searchText,
        not_ids: excludeIds
      },
      limit: 100,
      order: [{ column: 'id', direction: 'asc' }]
    }

    if (field.query && field.query.filters) {
      apiQuery.filters = Object.assign({ }, apiQuery.filters, field.query.filters)
    }

    api
      .get(field.references, { body: apiQuery })
      .then(res => res.json())
      .then(collection => {
        this.setState({
          autocompleteResults: Object.assign({}, this.state.autocompleteResults, {
            [field.references]: Object.assign({}, this.state.autocompleteResults[field.references], {
              [field.prop]: collection
            })
          })
        })
      })
  }

  handleAutocompleteSelection (field, chosenRequest, selectedIndex) {
    if (selectedIndex === -1) {
      // enter pressed in the autocomplete field
      return
    }

    this.setState({
      resource: Object.assign({}, this.state.resource, {
        [field.prop]: chosenRequest.id
      })
    })
  }

  handleValueChange (field, e, value, index = null) {
    this.setState({
      resource: Object.assign({}, this.state.resource, {
        [field.prop]: value
      })
    })
  }

  handleSubmit (e) {
    e && e.preventDefault()

    // Check if baseRecord is a function and call it with records, otherwise use it as an object
    const baseRecord = typeof this.props.baseRecord === 'function'
      ? this.props.baseRecord({
        records: this.props.associatedRecords,
        joinRecords: this.props.joinRecords
      })
      : this.props.baseRecord

    const body = { ...baseRecord, ...this.state.resource }

    api
      .post(this.props.apiPath, { body })
      .then(res => {
        res.json().then(data => {
          if (!res.ok) {
            this.setState({ errors: data.errors })
            return
          }

          this.props.setSnackbarMessage(`Successfully created #${data.id}`)
          this.setState(CreateAssociation.initialState)
          this.props.handleAssociationCreated(data)
        })
      })
  }

  render () {
    const formStyle = {
      maxWidth: 500
    }

    const buttonStyle = {
      margin: '1em 1em 0 0'
    }

    // Get the current baseRecord (either from function or object) to display in form
    const currentBaseRecord = typeof this.props.baseRecord === 'function'
      ? this.props.baseRecord({
        records: this.props.associatedRecords,
        joinRecords: this.props.joinRecords
      })
      : this.props.baseRecord

    // Merge baseRecord with current resource state for display
    const displayResource = { ...currentBaseRecord, ...this.state.resource }

    return (
      <div>
        <form onSubmit={this.handleSubmit.bind(this)} style={formStyle}>
          <FieldList
            fields={this.props.fields}
            autocompleteResults={this.state.autocompleteResults}
            autocompleteText={this.state.autocompleteText}
            handleAutocompleteSelection={this.handleAutocompleteSelection.bind(this)}
            handleAutocompleteUpdateInput={this.handleAutocompleteUpdateInput.bind(this)}
            handleAutocompleteFocus={this.handleAutocompleteFocus.bind(this)}
            resource={displayResource}
            errors={this.state.errors}
            onChange={this.handleValueChange.bind(this)}
          />

          <RaisedButton label='Add' primary onClick={this.handleSubmit.bind(this)} style={buttonStyle} />

        </form>
      </div>
    )
  }
}

// @ts-ignore
CreateAssociation.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  apiPath: PropTypes.string.isRequired,
  baseRecord: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]).isRequired,
  handleAssociationCreated: PropTypes.func.isRequired,
  excludeAutocompleteIds: PropTypes.object
}

// @ts-ignore
CreateAssociation.defaultProps = {
  excludeAutocompleteIds: { }
}

export default connect(null, { setSnackbarMessage })(CreateAssociation as any) as React.ComponentType<any>
